// Escape a value for interpolation into an HTML string (e.g. a SweetAlert
// `html` body). null and undefined render as an empty string.
const escapeHtml = (value: unknown): string =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export default escapeHtml;
